<template>
  <h1 class="flex flex-col items-center text-5xl font-semibold sm:text-5xl lg:text-7xl">
    Kamus Besar Bahasa
    <span class="bg-gray-100 px-4 font-black tracking-widest text-primary-800 dark:bg-gray-200">Indonesia</span>
  </h1>
</template>
